import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';
import {MCVectorOpenIcon} from '../../../Icons';

export function VectorBlock(props) {
  return (
    <div className={props.className}>
      <Image
        src={MCVectorOpenIcon}
        alt='micro centrifuge vector'
        className={`${props.className}_image`}
      />
    </div>
  );
}

VectorBlock.propTypes = {
  /**
   * ClassName to set on Component
   */
  className: PropTypes.string,
};

VectorBlock.defaultProps = {};
